import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIcon from "@/assets/icons/drag_handles.svg?react";
import { SortFieldRow } from "./SortFieldRow";
import { SortDirection } from "./types";

export const DraggableSortGroup = ({
  fieldName,
  selectedDirection,
  handleChange,
  handleRemove,
  columnsTitleCreator,
}: {
  fieldName: string;
  selectedDirection: SortDirection | null;
  handleChange: (newDirection: SortDirection | null) => void;
  handleRemove: () => void;
  columnsTitleCreator: (column: string) => string;
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: fieldName, disabled: false });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex flex-row items-center mt-1 mb-2 gap-2 text-[#2B4752]"
      data-testid={`sorting-active-row-${fieldName}`}
    >
      <button
        {...attributes}
        {...listeners}
        ref={setActivatorNodeRef}
        data-testid={`sorting-active-handle-${fieldName}`}
        className="cursor-move touch-none shrink-0"
        type="button"
      >
        <DragIcon />
      </button>
      <SortFieldRow
        fieldName={fieldName}
        selectedDirection={selectedDirection}
        onChange={handleChange}
        columnsTitleCreator={columnsTitleCreator}
      />
      <Button
        data-testid={`sort-remove-${fieldName}`}
        type="text"
        onClick={handleRemove}
        icon={<CloseOutlined className="text-xs text-[#00000073]" />}
        size="small"
        className="shrink-0 w-8 h-8"
      />
    </div>
  );
};
